import { useParams } from "react-router-dom";
import { useFetchAthleteQuery } from "../../../store";
import CalendarTables from "../../../components/calendar/CalendarTables";
import CalendarForm from "../../../components/calendar/wizard/CalendarForm";
import { useState } from "react";
import FormModal from "../../../components/modals/FormModal";

export default function CalendarManager(){
  let { id } = useParams();
  const { data, error, isLoading} = useFetchAthleteQuery(id);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let athlete;
  let content;
  if (isLoading) {
    content = <div> Loading...</div>;
    return content;
  }
  if (error) {
    content = <div> Error: {error.message}</div>;
    return content;
  }
  else{
    athlete = data[0];
    content = <div className="space-y-12">
      <div className="border-b border-gray-900/10 pb-12 mt-5">
        <button type="button"
            className='bg-indigo-600 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mx-1 inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm'
            onClick={() => setIsModalOpen(true)}
          >
          Configure new calendar
        </button>
        <CalendarTables />
      </div>
      <div className="pb-12">
        <FormModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Configure Calendar"
          maxWidth="max-w-3xl"
          closeButtonText="Cancel"
          showCloseButton={false}
          size="l"
        >
          <CalendarForm 
            onClose={() => setIsModalOpen(false)}
            onSubmit={(formData) => {
              console.log("Configuration saved:", formData);
              // Aquí puedes hacer lo que necesites con los datos
            }}
          />
        </FormModal>
      </div>
    </div>
  }
  return (
    content
  )
}